import { z } from 'zod';

/** Shared completion state for durable content and public readback. */
export const investigationCompletionStatesSchema = z.object({
  evidence: z.enum(['complete', 'incomplete']), reasoning: z.enum(['complete', 'incomplete']),
  narration: z.enum(['complete', 'interrupted', 'truncated', 'refused', 'invalid', 'absent']),
  persistence: z.enum(['pending', 'persisted']),
}).strict();
